import httpClient from '@/http-client'

export const getFolder = (id, Options = {}) => {
  return httpClient
    .get(`/api/browse/folders/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getBrowseSearch = (Options = {}) => {
  return httpClient
    .get('/api/browse/search', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getFolderTree = (Options = {}) => {
  return httpClient
    .get('/api/browse/navigation', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  getFolder,
  getBrowseSearch,
  getFolderTree
}
